import {
    type ContentReference,
    type Revision,
    type RevisionPageDocument,
    type RevisionPageDocumentCover,
    RevisionPageType,
} from '../../types';
import { isYValue, jsonToY, mutations, yToJSON } from '../../utils';
import { updatePageInRevision } from './updatePageInRevision';

/**
 * Add a cover to page.
 */
export function addPageCoverInRevision<Ref extends ContentReference>(
    revision: mutations.MutableData<Revision>,
    pageId: string,
    coverOptions: { ref?: Ref; refDark?: Ref } | undefined = undefined
): void {
    updatePageInRevision(revision, pageId, (page: mutations.MutableData<RevisionPageDocument>) => {
        const type = mutations.get(page, 'type');
        if (type !== RevisionPageType.Document) {
            return;
        }

        const existingCover = mutations.get(page, 'cover');
        const cover: RevisionPageDocumentCover = {
            ...(isYValue(existingCover) ? yToJSON(existingCover) : existingCover),
            ...coverOptions,
            yPos: 0,
        };

        mutations.set(page, 'cover', isYValue(revision) ? jsonToY(cover) : cover);
    });
}

/**
 * Remove the cover of a page.
 */
export function removePageCoverInRevision(
    revision: mutations.MutableData<Revision>,
    pageId: string
): void {
    updatePageInRevision(revision, pageId, (page: mutations.MutableData<RevisionPageDocument>) => {
        const type = mutations.get(page, 'type');
        if (type !== RevisionPageType.Document) {
            return;
        }

        mutations.del(page, 'cover');
    });
}

/**
 * Move the page cover image to the given position.
 */
export function movePageCoverInRevision(
    revision: mutations.MutableData<Revision>,
    pageId: string,
    yPos: number
): void {
    updatePageInRevision(revision, pageId, (page: mutations.MutableData<RevisionPageDocument>) => {
        const type = mutations.get(page, 'type');
        if (type !== RevisionPageType.Document) {
            return;
        }

        const cover = mutations.get(page, 'cover');
        if (!cover) {
            return;
        }

        // @ts-expect-error
        mutations.set(cover, 'yPos', yPos);
    });
}
